import React from 'react';
import { NavLink } from 'react-router-dom';

const ReposIpfsShipyardIpldExplorerComponents = () => (
  <div id='content' className='pt3 pr4 pl4 w-100'>
    <h1><span className='nav-category'>Repo:</span> ipfs-shipyard/ipld-explorer-components</h1>

    <p>This repo contains the source code for the React components used within <NavLink to='/repos/ipfs-shipyard/ipld-explorer'>IPLD Explorer</NavLink> and available for embedding in other core- and community-built projects. <a href="https://github.com/ipfs-shipyard/ipld-explorer-components" target="_blank" rel="noopener noreferrer">View on GitHub</a></p>

    <h2>Nothing to see here!</h2>
    <p>This repo isn’t examined in detail because its code is primarily used as a constituent part of one or more other user-facing repos.</p>
  </div>
);

export default ReposIpfsShipyardIpldExplorerComponents;
